import { api } from '@api/api2';
import { ObjectsPayload } from '../interfaces';
import { ticketCardApi } from './ticket';
import { ticketAdditionalFieldsApi } from './ticket-additional-fields';
import { ticketAssigneesApi } from './ticket-assignees';
import { ticketDeclarantApi } from './ticket-declarant';
import { ticketGeneralApi } from './ticket-general';
import { ticketInvoiceApi } from './ticket-invoice';
import { ticketRepeatApi } from './ticket-repeat';
import { ticketTimeApi } from './ticket-time';
import { ticketTmcApi } from './ticket-tmc';
import { ticketWorksApi } from './ticket-works';
import { ticketsApi } from './tickets';

const getObjects = (payload: ObjectsPayload) =>
  api.v1('post', 'tck/objects/detailed', payload);

export const ticketApi = {
  getObjects,
  ...ticketGeneralApi,
  ...ticketsApi,
  ...ticketCardApi,
  ...ticketInvoiceApi,
  ...ticketAssigneesApi,
  ...ticketRepeatApi,
  ...ticketWorksApi,
  ...ticketTmcApi,
  ...ticketDeclarantApi,
  ...ticketTimeApi,
  ...ticketAdditionalFieldsApi,
};
